import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';

const MenuListItem = ({ handleClick, href, itemName, items, name }) => {
  const hasToRedirect = itemName || !items.length;

  return (
    <li className="menu__list-item menu__list-item--responsive-nav">
      {hasToRedirect ? (
        <Link href={href} onClick={() => handleClick({ itemAction: 'close' })}>
          {name}
        </Link>
      ) : (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a role="button" onClick={() => handleClick({ itemName: name, itemHref: href })}>
          {name}
        </a>
      )}
    </li>
  );
};

MenuListItem.propTypes = {
  handleClick: PropTypes.func.isRequired,
  href: PropTypes.string,
  itemName: PropTypes.string.isRequired,
  items: PropTypes.array,
  name: PropTypes.string
};

MenuListItem.defaultProps = {
  href: '/',
  items: [],
  name: []
};

export default MenuListItem;
